// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"global__msignaturepad___1xyFA","m-signature-pad--body":"global__m-signature-pad--body___294gc","m-signature-pad--footer":"global__m-signature-pad--footer___1ovE1","description":"global__description___2AY3b","button":"global__button___9A8wp","clear":"global__clear___17tKU","save":"global__save___2gH0V","m-signature-pad":"global__m-signature-pad___33wqO","github":"global__github___1v0AO"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/styles/global.scss
// module id = jNK8
// module chunks = client